import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { MinMaxType } from '@utils/types/searchListingsContext';
import { useClickOutside } from '@utils/hooks/useClickOutside';
import { MinMaxInputs } from '@components/search/minMaxInputs';
import { renderPriceValue } from '@components/search/utils';

import styles from './styles.module.scss';

type Props = {
  value: MinMaxType;
  onChange: (value: MinMaxType) => void;
  isMonthly?: boolean;
} & BaseComponentProps;

PriceSelector.defaultProps = {
  value: { min: '', max: '' },
  isMonthly: false,
};

export function PriceSelector(props: Props) {
  const { containerStyle, value, onChange, isMonthly } = props;
  const [showContainer, setShowContainer] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleContainer = () => setShowContainer((value) => !value);

  const closeContainer = () => setShowContainer(false);

  useClickOutside(containerRef, closeContainer);

  const onClearFilter = () => {
    if (value?.min || value?.max) {
      onChange({ min: '', max: '' });
    }
    closeContainer();
  };

  return (
    <div
      ref={containerRef}
      className={clsx([styles.priceSelector, containerStyle])}
    >
      <div className={styles.priceSelector__toggle} onClick={toggleContainer}>
        {renderPriceValue(value, isMonthly)}
      </div>

      {showContainer && (
        <div
          className={styles.priceSelector__popup}
          onClick={(e) => e.stopPropagation()}
        >
          <MinMaxInputs
            value={value}
            onChange={onChange}
            inputStyle={styles.priceSelector__selector}
            type="price"
            withDebounce
            suggestedValues={[
              5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000,
              50000,
            ]}
          />

          <div className={styles.priceSelector__clear} onClick={onClearFilter}>
            Clear
          </div>
        </div>
      )}
    </div>
  );
}
